import moment from "moment";
import "moment/locale/es";
// import { dineroDisabledMask } from "../Components/Items";
// import xmlToJson from "../Components/xmlToJson";
moment.locale("es");

const segundoTicketPdf = (data) => {
  const empresa = data.respuestaFactura.empresa
  // const cliente = data.respuestaFactura.dataSat.Receptor;
  const dataSat = data.respuestaFactura.dataSat
  const logo = empresa.logo.base64Completa;
  const conceptos = dataSat.Conceptos;



  // Genera dinámicamente las filas para la tabla de conceptos
  const filasConceptos = conceptos.map((concepto) => {
    return [
      {
        text: concepto.Descripcion,
        style: "tProductsBody",
        fontSize: 8,
      },
      {
        text: concepto.Unidad,
        style: "tProductsBody",
        alignment: "center",
        fontSize: 7,
      },
      {
        text: concepto.Cantidad,
        style: "tProductsBody",
        alignment: "center",
        fontSize: 7,
      },
    ]
  });

  const textoInsumosQR = conceptos.map(c => `• ${c.Descripcion} ${c.Unidad} - ${c.Cantidad}`).join('\n').slice(0, 1800); // evita un QR gigante;

  return {
    pageSize: { width: 206, height: "auto" }, // 80 mm de ancho, altura ajustable
    pageMargins: [10, 10, 10, 10],
    content: [
      {
        image: logo,
        fit: [141.73, 56.692],
        alignment: "center",
      },
      {
        text: empresa.nombreComercial ?  empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre + " " + empresa.apellidoPaterno + " " + empresa.apellidoMaterno),
        style: "header",
        margin: [0, 10, 0, 0],
        alignment: "center",
        fontSize: 12,
      },
      // {
      //   text: empresa.rfc,
      //   style: "header",
      //   alignment: "center",
      //   fontSize: 10,
      // },
      // {
      //   text: empresa.calle + " " + empresa.numeroCalle + " " + (empresa.numeroInterior ? empresa.numeroInterior : " "),
      //   style: "header",
      //   alignment: "center",
      //   fontSize: 10,
      // },
      // {
      //   text: empresa.colonia.nombre + " " + empresa.colonia.cp + " " + empresa.municipio.nombre + " " + empresa.municipio.nombre + " " + empresa.pais.nombre,
      //   style: "header",
      //   alignment: "center",
      //   fontSize: 10,
      // },
      // {
      //   text: `Regimen Fiscal: (${empresa.regimenFiscal.c_RegimenFiscal}) ${empresa.regimenFiscal.descripcion}`,
      //   style: "header",
      //   alignment: "center",
      //   fontSize: 10,
      // },

      { text: `Nº ${data.factura ? "Factura" : "Remision"} - ${dataSat.Serie} - ${dataSat.Folio}`, style: "header", margin: [0, 10, 0, 0], fontSize: 10, },

      // {
      //   margin: [0, 10, 0, 0],
      //   table: {
      //     widths: ["100%"], // Solo dos columnas
      //     body: [
      //       [
      //         { text: cliente.Nombre, style: "tHeaderValue", fontSize: 10, },
      //       ],
      //     ],
      //   },
      //   layout: "noBorders",
      // },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["50%", "25%", "25%"], // Ajuste de proporciones
          body: [
            // Encabezado de la tabla
            [
              {
                text: "VALE",
                colSpan: 3,
                style: "tTitleHeader",
                alignment: "center",
                fontSize: 12,
                margin: [0, 0, 0, 0],
              },
              {},
              {},
            ],
            [
              {
                text: "CÓDIGO - DESCRIPCIÓN",
                colSpan: 3,
                style: "tProductsHeader",
                alignment: "center",
                fontSize: 12,
                fillColor: "#f2f2f2", // Color de fondo
                margin: [0, 5, 0, 5],
              },
              {},
              {},

            ],
            [
              {
                text: "DESCRIPCIÓN",
                style: "tProductsHeader",
                alignment: "center",
                fontSize: 7,
              },
              {
                text: "UM",
                style: "tProductsHeader",
                alignment: "center",
                fontSize: 7,
              },
              {
                text: "CANT",
                style: "tProductsHeader",
                alignment: "center",
                fontSize: 7,
              },
            ],

            ...filasConceptos,
          ],
        },

        layout: {
          hLineWidth: function (i, node) {
            return i === 2 ? 0.5 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function () {
            return "#f2f0f0";
          },
          paddingTop: function (i, node) {
            return i % 2 === 0 ? 10 : 1;
          },
        },
      },
      {
        stack: [
          {
            qr: textoInsumosQR,
            fit: 115,
            alignment: "center",
            eccLevel: "Q",
            margin: [0, 5, 0, 5],
          },
          {
            text: "QR del ticket",
            style: "text",
            alignment: "center",
            fontSize: 6,
          },
        ]
      }
    ],
    styles: {
      header: {
        bold: true,
        fontSize: 15,
      },
    },
    defaultStyle: {
      fontSize: 12,
    },
  };

};

export default segundoTicketPdf;
